import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../services/api";

const SetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match");
            return;
        }
        if (newPassword.length < 6) {
            setMessage("Password must be at least 6 characters");
            return;
        }
        setLoading(true);
        try {
            await api.post("/users/set-password", { token, newPassword });
            setMessage("Password set! You can now login.");
            setTimeout(() => window.location.href = "/login", 2000);
        } catch (err) {
            setMessage(err.response?.data || "Error setting password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: "400px", margin: "50px auto", padding: "20px", border: "1px solid #ccc", borderRadius: "8px" }}>
            <h2>Set Your Password</h2>
            <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{ width: "100%", padding: "8px", margin: "8px 0" }}
            />
            <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ width: "100%", padding: "8px", margin: "8px 0" }}
            />
            <button onClick={handleSubmit} disabled={loading} style={{ width: "100%", padding: "10px" }}>
                {loading ? "Setting..." : "Set Password"}
            </button>
            {message && <p style={{ marginTop: "10px", color: message.includes("success") ? "green" : "red" }}>{message}</p>}
        </div>
    );
};

export default SetPassword;